module.exports = __webpack_public_path__ + "img/mi-star-rate.b02d4ec2.svg";